import { sql } from 'drizzle-orm';
import { pgTable, text, uuid, pgEnum, bigserial, index, bigint, primaryKey, integer, unique, foreignKey, customType, } from 'drizzle-orm/pg-core';
import { orgId } from './models/org-id';
import { isoTimestamp } from './utils';
const binary = customType({
    dataType() {
        return 'bytea';
    },
});
export const SyncActionTypeEnum = pgEnum('sync_action_type', [
    'insert',
    'update',
    'delete',
]);
export const SyncAction = pgTable('sync_action', {
    syncId: bigserial('sync_id', {
        mode: 'number',
    }).notNull(),
    transactionId: bigint('transaction_id', {
        mode: 'number',
    })
        .notNull()
        .default(sql `pg_current_xact_id()::text::bigint`),
    timestamp: isoTimestamp('timestamp')
        .notNull()
        .default(sql `now()`),
    modelName: text('model_name').notNull(),
    modelId: uuid('model_id').notNull(),
    action: SyncActionTypeEnum('type').notNull(),
    data: binary('data'),
    dbVersion: integer('db_version').notNull(),
    orgId,
}, (table) => ({
    pk: primaryKey({ columns: [table.syncId, table.orgId] }),
    orgIndex: index().on(table.orgId, table.syncId),
}));
export const SyncGroup = pgTable('sync_group', {
    id: uuid('id').primaryKey().defaultRandom(),
    pattern: text('pattern').notNull(),
    orgId,
}, (table) => ({
    orgIndex: index().on(table.orgId, table.id),
    patternIndex: unique().on(table.orgId, table.pattern),
}));
export const SyncGroupAction = pgTable('sync_group_action', {
    syncId: bigint('sync_id', {
        mode: 'number',
    }).notNull(),
    syncGroupId: uuid('sync_group_id')
        .notNull()
        .references(() => SyncGroup.id),
    orgId,
}, (table) => ({
    pk: primaryKey({ columns: [table.syncGroupId, table.syncId, table.orgId] }),
    syncActionFk: foreignKey({
        columns: [table.syncId, table.orgId],
        foreignColumns: [SyncAction.syncId, SyncAction.orgId],
    }).onDelete('cascade'),
}));
//# sourceMappingURL=sync-action.js.map